import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { DataObject } from 'src/app/core/models/core.models';
import { ObjectPersistenceService } from 'src/app/core/services/object-persistence.service';

@Component({
  selector: 'app-export-status',
  templateUrl: './export-status.component.html',
  styleUrls: ['./export-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ExportStatusComponent implements OnInit {
  @Input() exportObject: DataObject;

  private readonly objectPersistence = inject(ObjectPersistenceService);

  constructor() {
    this.exportObject = {} as DataObject;
  }

  ngOnInit() {}

  cancel() {
    this.objectPersistence.cancelShare(this.exportObject.id);
  }
}
